import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { usersService } from '../../services/users.service';
import { alert } from '../../services/alert.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-forgot-email',
  templateUrl: './forgot-email.component.html',
  styleUrls: ['./forgot-email.component.scss'],
  standalone: false,
})
export class ForgotEmailComponent implements OnInit {
  userEmail: string = '';


  constructor(
    private userService: usersService,
    private alert: alert,
    private dialog: MatDialog
  ){

  }

  ngOnInit(): void {
    
  }

  emailForgot(form: any) {
    if (!form.valid) {
      return
    }
    let data = {
      email: this.userEmail
    }
    this.userService.forgetPassword(data).subscribe(res => {
      this.alert.responseAlert(res.message, 'success');
      this.dialog.closeAll();
    })
  }

  
}
